import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { SwiperOptions } from 'swiper/types'
import { TranslateService } from '@ngx-translate/core'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { SharedService } from '@flowaccount/landing'
import { SquidexService } from '../../../services/squidex.service'
import { SquidexCacheService } from '../../../services/squidex-cache.service'

export interface ICustomTextList {
  title: string
  detail: string
  button: string
}

@Component({
  selector: 'flowaccount-review-setion',
  templateUrl: './review-setion.component.html',
  styleUrls: ['./review-setion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReviewSetionComponent implements OnInit {
  @Input() isAccountingImage = false
  @Input() bgColorTheme = 'blue-light-bg'
  @Input() customTextList: ICustomTextList

  public serviceList$: Observable<object[]>
  public filteredReviewList$: Observable<object[]>
  public config: SwiperOptions
  private contentSquidex = 'flowaccount-review'
  private contentScully = 'REVIEW_SECTION_KEY'

  constructor(
    public sharedService: SharedService,
    public translate: TranslateService,
    private squidexService: SquidexService,
    private squidexCacheService: SquidexCacheService,
    private transferState: TransferStateService,
  ) {}

  ngOnInit(): void {
    if (isScullyGenerated()) {
      this.serviceList$ = this.transferState.useScullyTransferState<object[]>(this.contentScully, of([]))
    } else {
      this.serviceList$ = this.squidexCacheService
        .getServiceList$(
          this.contentScully,
          this.contentSquidex,
          this.squidexService.getContentSquidexApi.bind(this.squidexService),
        )
        .pipe(
          tap((data) => {
            this.transferState.setState(this.contentScully, data)
          }),
        )
    }

    this.filterReviewList()
    this.swiperConfig()
  }

  filterReviewList(): void {
    this.filteredReviewList$ = this.serviceList$.pipe(
      map((items: any[]) =>
        items.filter((item) => {
          const type = item?.data?.cardBusinessModelType?.iv
          return this.isAccountingImage ? type === 'สำนักงานบัญชีพาร์ตเนอร์' : type !== 'สำนักงานบัญชีพาร์ตเนอร์'
        }),
      ),
    )
  }

  linkVideo(youtubeURL: string) {
    return this.sharedService.openVideoTutorialModal(youtubeURL)
  }

  swiperConfig() {
    this.config = {
      observer: true,
      observeParents: true,
      speed: 700,
      mousewheel: true,
      slidesPerView: 1,
      navigation: false,
      breakpoints: {
        1000: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        400: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        pauseOnMouseEnter: true,
      },
      keyboard: false,
      scrollbar: false,
      pagination: {
        clickable: true,
        dynamicBullets: true,
      },
      watchSlidesProgress: true,
      injectStyles: [
        `
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #2898cb;
        opacity: 0.4;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
      }
      `,
      ],
    }
  }
}
